import { useAnalytics } from '@growth/use-analytics';

var useCardLoad = function useCardLoad() {
  var timerId;
  var totalCardsLoadCount = 0;
  var _useAnalytics = useAnalytics(),
    analyticsTrackAll = _useAnalytics.analyticsTrackAll;
  var fireLoadEvent = function fireLoadEvent(event, delayTime) {
    if (delayTime === void 0) {
      delayTime = 10;
    }
    totalCardsLoadCount += 1;
    if (timerId) clearTimeout(timerId);
    timerId = setTimeout(function () {
      if (totalCardsLoadCount) {
        analyticsTrackAll(event, {
          custom1: String(totalCardsLoadCount)
        });
      }
    }, delayTime);
  };
  return {
    fireLoadEvent: fireLoadEvent
  };
};

export { useCardLoad };
